import React from 'react';
import './ZoneAnalysis.css';

const ZoneAnalysis = ({ homeTeamName, awayTeamName, zoneStats }) => {
    return (
        <div className="stats-section">
            <h3 className="stats-section-title">Field Zone Analysis</h3>
            <div className="zone-stats">
                {Object.entries(zoneStats).map(([zone, data]) => (
                    <div key={zone} className="zone-stat">
                        <div className="zone-header">
                            <div className={`zone-indicator ${zone.toLowerCase().replace(' ', '-')}`}></div>
                            <h4 className="zone-name">{zone}</h4>
                            <div className="zone-total">{data.total} events</div>
                        </div>
                        
                        {data.total > 0 && (
                            <>
                                <div className="zone-split-bar">
                                    <div 
                                        className="zone-home-part"
                                        style={{ width: `${data.homePercentage}%` }}
                                    >
                                        {data.homePercentage}%
                                    </div>
                                    <div 
                                        className="zone-away-part"
                                        style={{ width: `${data.awayPercentage}%` }}
                                    >
                                        {data.awayPercentage}%
                                    </div>
                                </div>
                                <div className="zone-labels">
                                    <div className="zone-home-label">
                                        {homeTeamName}: {data.home} events
                                    </div>
                                    <div className="zone-away-label">
                                        {awayTeamName}: {data.away} events
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ZoneAnalysis;